import { MessageBus } from '@podium/browser';
import decodeObject from '@schibsted-nmp/search-frontend-utils/decodeObject.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import type { AppProps } from './AppProps';
import {
    SortingInfoModal,
    type SortingInfoModalProps,
} from './SortingInfoModal';
import { loadAndActivateI18n } from './i18n';

const PODLET_NAME = 'search-sorting-info-podlet';

const MESSAGE_BUS_CHANNEL = 'search-sorting-info';
const MESSAGE_BUS_TOPIC = 'open';

const rootElement = document.querySelector(`${PODLET_NAME}-isolated`)
    ?.shadowRoot;

if (rootElement) {
    const propsEle = rootElement.querySelector(
        `script[type="application/json"][data-props]`,
    );
    if (propsEle) {
        try {
            const props = decodeObject<AppProps>(propsEle.textContent ?? '{}');

            loadAndActivateI18n(props.locale);
            initLink(rootElement);
            renderModal(rootElement, props);
        } catch (err) {
            throw new Error(
                `React(render): Props (${
                    propsEle.textContent
                }) were provided but parse failed: Error message was: ${
                    (err as Error).message
                }`,
            );
        }
    }
}

function initLink(rootElement: ShadowRoot) {
    const linkEle = rootElement.querySelector(`#${PODLET_NAME}-link`);
    if (linkEle) {
        const messageBus = new MessageBus();
        linkEle.addEventListener('click', (ev) => {
            ev.preventDefault();
            messageBus.publish(MESSAGE_BUS_CHANNEL, MESSAGE_BUS_TOPIC);
        });
    }
}

function renderModal(shadowRoot: ShadowRoot, appProps: AppProps) {
    const modalEle = shadowRoot.querySelector(`#${PODLET_NAME}-modal`);
    if (modalEle) {
        const props: SortingInfoModalProps = {
            messageBusConfig: {
                channel: MESSAGE_BUS_CHANNEL,
                topic: MESSAGE_BUS_TOPIC,
            },
            sortingInfo: appProps.sortingInfo,
        };

        const root = createRoot(modalEle);
        root.render(React.createElement(SortingInfoModal, props));
    }
}
